export enum Locales {
    EN = 'en',
    KR = 'kr',
    VN = 'vn',
}

export const LOCALES = [
    { value: Locales.EN, caption: 'English' },
    { value: Locales.KR, caption: 'Korean' },
    { value: Locales.VN, caption: 'Việt Nam' }
]